module.exports = "/media/swap_white.a54568c2.png";